<template>
    <div>
        <CompaniesEdit/>
        <router-view></router-view>
    </div>
</template>

<script>
import CompaniesEdit from '../../components/companies/CompaniesEdit.vue';

export default {
    name: 'CompaniesLayout',
    components: {CompaniesEdit},
};
</script>

<style scoped>

</style>